<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="活动名称：" name="activity_name"></c-form-item>
                    <c-form-item type="checkbox" label="活动状态：" name="start_state" :options="activityState"></c-form-item>
                    <c-form-item type="checkbox" label="启/禁用状态" name="state" :options="stateOptions"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_activity_secondkill_edit" color="sys" @click="navigateTo('/activity_secondkill_add')">新建活动</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="活动状态"
                        name="start_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="启/禁用状态"
                        name="state"
                        width="90"
                >
                    <template v-slot="row">
                        <c-switch v-if="auth('b_activity_secondkill_edit') && row.data.start_state == 0||row.data.start_state == 1" :value="row.data.state == 2" text="启用,禁用"
                                  @change="changeActivityState(row, arguments[0], arguments[1])"></c-switch>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 1" style="color: darkgray">禁用</strong>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 2" style="color: green">启用</strong>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>

              <c-table-column
                  label="活动预告"
                  name="activity_notice"
                  width="120"
              >
                <template v-slot="{data}">
                  <span v-if="data.activity_notice == -1" style="color:gray">不预告</span>
                  <span v-if="data.activity_notice == 0" style="color:blue">立即预告</span>
                  <span v-if="data.activity_notice == 1">提前<span style="color:red">{{data.activity_notice_time}}</span>小时预告</span>
                </template>
              </c-table-column>

              <c-table-column
                  label="活动标签"
                  name="tags"
                  width="120"
              ></c-table-column>

              <c-table-column
                  label="自取取消时间"
                  name="cancel_time"
                  width="120"
              >
                  <template v-slot="{data}">
                      <span v-if="data.cancel_time" style="color:gray">
                          <span style="color:red">{{data.cancel_time}}</span>分钟
                      </span>
                      <span v-else>--</span>
                  </template>
              </c-table-column>

              <c-table-column
                        label="活动时间"
                        width="280"
                >
                    <template v-slot="{data}">{{data.begin_date}} - {{data.end_date}}</template>
              </c-table-column>

              <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                >
              </c-table-column>
              <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
              >
                    <template v-slot="row">
                        <c-table-button power="m_activity_secondkill" @click="navigateTo(`/activity_secondkill_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_activity_secondkill_edit" v-if="row.data.state == 1 || row.data.start_state == 2"
                                        @click="navigateTo(`/activity_secondkill_edit/${row.data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_activity_secondkill_edit" v-if="row.data.state == 1 || row.data.start_state == 2"
                                        @click="deleteActivity(row)">删除</c-table-button>
                    </template>
              </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
        name: 'm_activity_secondkill',

        data() {
            return {
                activityState: [
                    {name: '未开始',value: 0},
                    {name: '进行中',value: 1},
                    {name: '已结束',value: 2}
                ],
                stateOptions: [
                    {name: '禁用',value: 1},
                    {name: '启用',value: 2}
                ]
            }
        },
        computed: {
            ...mapState(['systemConfig', 'userInfo']),
            ...mapGetters({
                auth: 'power'
            }),
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('activitySecondkillList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activitySecondkill/list',
                    data
                });
            },
            /**
             * 活动启禁用
             * @param state true = 启用  false=禁用
             */
            changeActivityState(item,state, stop) {
                stop();
                this.$confirm({
                    text: '确定要'+(state?"启用":"禁用")+'砍价活动【'+item.data.activity_name+'】吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/updateActivityState',
                            data: {
                                id: item.data.id,
                                state:state?2:1
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state ? '启用成功' : '禁用成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                this.$confirm({
                    text: '确定要删除此活动【'+item.data.activity_name+'】吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/remove',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            copyActivity(item) {
                this.request({
                    url: '/activitySecondkill/copy',
                    data: {
                        id: item.data.id
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '复制成功'
                        });
                        this.$refs.table.update();
                    }
                });
            },
            otherConfig(){
                this.request({
                    url: '/activitySecondkill/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.editForm.clear();
                        this.$refs.editForm.set({"BARGAIN_ACTIVITY_BANNER":data.BARGAIN_ACTIVITY_BANNER,"BARGAIN_ACTIVITY_REMARK":data.BARGAIN_ACTIVITY_REMARK});
                        this.$refs.editDialog.open();
                    }
                });

            },
            submitForm(stop) {
                stop();
                let submitUrl = '/activitySecondkill/updateConfig';
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        BARGAIN_ACTIVITY_BANNER: [{
                            type: 'empty',
                            word: '请上传专区图片'
                        }]
                    },
                    dataFormatter: data => {
                        let configs = [];
                        let banner={},remarks={};
                        banner.id="11";
                        banner.config_item_value= data.BARGAIN_ACTIVITY_BANNER;
                        remarks.id="12";
                        remarks.config_item_value= data.BARGAIN_ACTIVITY_REMARK;
                        configs.push(banner,remarks);
                        data.platform_config_list = configs;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    },
                });
            }
        }
    }
</script>